export const GOOGLE_CLIENT_ID = '837113347618-b0c8buue2i66tvvaeint1lol88rmshqi.apps.googleusercontent.com';
export const ALLOWED_DOMAIN = '@sleepmetrics.com';
export const COACHING_EMAIL = 'clinicalteam@sleepmetrics.com';
export const AIRVIEW_BASE   = 'https://airview.resmed.com/patients';
export const ADMIN_GROUP    = 'dashboard-admins@sleepmetrics.com';
export const RC_CLIENT_ID   = 'bQ67XFRTaajcUQNW7GMS3U';
export const C = {
  bg:'#F0F2F7', surface:'#FFFFFF', card:'#FFFFFF', border:'#E2E6EF',
  text:'#141928', muted:'#687398', faint:'#D4D9E8', green:'#176B38',
  red:'#C52918', orange:'#9A7100', teal:'#006B69', blue:'#0A52B8', purple:'#6930A8',
};
export const COACHING_PHONE = '+15038873531';

// ResMed Action Groups, in coach-priority order (Compliance Risk is #1 per John).
// key = the group_key stored in patient_groups; label/icon/color drive the tabs.
export const ACTION_GROUPS = [
  { key:'US_ComplianceRisk',              label:'Compliance Risk',        short:'Low-usage trend in first 90 days', icon:'🔴', color:C.red },
  { key:'US_NoDataReceived',              label:'No Data Received',       short:'Machine not transmitting — high priority, not call-now', icon:'📡', color:C.orange },
  { key:'US_ComplianceNotMet',            label:'Compliance Not Met',     short:'Below the compliance threshold',   icon:'⚠️', color:C.orange },
  { key:'US_OngoingUsageFollowUp',        label:'Ongoing Usage Follow-Up',short:'Established patients to monitor',   icon:'📈', color:C.blue },
  { key:'US_TherapyIssues',               label:'Therapy Issues',         short:'Leak / AHI / mask concerns',        icon:'🩺', color:C.purple },
  { key:'US_RepapEligible',               label:'Re-PAP Eligible',        short:'Device past recommended lifespan',  icon:'🔁', color:C.blue },
  { key:'US_ComplianceMet',               label:'Compliance Met',         short:'Meeting compliance — encouragement',icon:'✅', color:C.green },
  { key:'US_OngoingNIPPVComplianceMet',   label:'NIPPV Compliance Met',   short:'NIPPV patients, compliant',         icon:'✅', color:C.green },
  { key:'US_OngoingNIPPVComplianceNotMet',label:'NIPPV Not Met',          short:'NIPPV patients, not compliant',     icon:'⚠️', color:C.orange },
];
